<div [formGroup]="parentFormGroup" class="form-container">
  <mat-form-field appearance="outline">
    <mat-label i18n>Venue</mat-label>
    <input matInput [matAutocomplete]="venue" id="venue-id" formControlName="id">
    <mat-autocomplete requireSelection #venue="matAutocomplete" [displayWith]="getVenueName.bind(this)">
      <mat-option *ngFor="let option of filteredVenueNames | async" [value]="option.id">
        {{ option.name }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</div>
